import Marquee from "react-fast-marquee";

const SECTORS = [
  "Agriculture", "Technology", "Retail & Trade", "Food & Hospitality",
  "Health & Wellness", "Education", "Finance & Legal", "Construction & Real Estate",
  "Creative & Media", "Fashion & Beauty", "Manufacturing", "Transport & Logistics",
  "Professional Services",
];

export const SectorMarquee = () => (
  <div className="border-y border-stone_warm bg-[#F3F0EB] py-8" data-testid="sector-marquee">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {SECTORS.map((sector) => (
        <span key={sector} className="mx-12 flex items-center gap-12">
          <span className="whitespace-nowrap font-serif text-2xl font-light italic tracking-tight text-charcoal/75">
            {sector}
          </span>
          <span className="inline-block h-1.5 w-1.5 rotate-45 bg-gold" aria-hidden="true" />
        </span>
      ))}
    </Marquee>
  </div>
);
